import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authApi, getApiErrorMessage } from '../utils/api';
import SimplizeLogo from './SimplizeLogo';
import SimplizeOriginalLogo from './SimplizeOriginalLogo';

export default function ForgotPasswordPage() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;
        setError('');
        setIsSubmitting(true);
        try {
            await authApi.forgotPassword(email.trim());
            setIsSuccess(true);
        } catch (err) {
            setError(getApiErrorMessage(err, 'Gửi yêu cầu thất bại. Vui lòng thử lại sau.'));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex flex-col overflow-y-auto" style={{ background: '#f8f8f7' }}>
            <div className="flex-1 flex flex-col items-center justify-center px-4 py-10">
                <SimplizeLogo className="h-[35px] w-auto mb-[32px]" />
                <div className="w-[404px] border border-[#FFFFFF] bg-white rounded-[16px] p-[24px_32px]">
                    <div className="flex flex-col items-center mb-[32px]">
                        <h1 className="text-[28px] leading-[36px] font-bold text-[#111827] text-center mb-[8px]">
                            Quên mật khẩu
                        </h1>
                        <p className="text-[16px] text-[#a0a0a5] text-center">
                            {isSuccess 
                                ? 'Chúng tôi đã gửi hướng dẫn đặt lại mật khẩu vào email của bạn.' 
                                : 'Nhập email của bạn để lấy lại mật khẩu'}
                        </p>
                    </div>

                    {!isSuccess ? (
                        <form onSubmit={handleSubmit}>
                            <div className="space-y-[16px]">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Nhập địa chỉ email của bạn..."
                                    className="w-full h-[48px] px-[16px] rounded-[12px] border border-[#ECECED] bg-white text-[16px] text-[#111827] focus:outline-none focus:border-[#999] placeholder:text-[#a0a0a5] transition-colors"
                                    required
                                />
                            </div>

                            {error && <p className="text-xs text-red-500 mt-2">{error}</p>}

                            <button
                                type="submit"
                                disabled={isSubmitting || !email}
                                className={`w-full h-[48px] mt-8 rounded-[12px] text-white text-[16px] font-medium transition-colors cursor-pointer ${
                                    isSubmitting || !email ? 'bg-[#999]' : 'bg-[#111827] hover:bg-[#333]'
                                }`}
                            >
                                {isSubmitting ? 'Đang xử lý...' : 'Lấy lại mật khẩu'}
                            </button>
                        </form>
                    ) : (
                        <button
                            onClick={() => navigate('/login')}
                            className="w-full h-[48px] mt-4 rounded-[12px] bg-[#111827] text-white text-[16px] font-medium hover:bg-[#333] transition-colors cursor-pointer"
                        >
                            Quay lại đăng nhập
                        </button>
                    )}

                    <div className="mt-8 text-center">
                        <span className="text-[13px] text-[#a0a0a5]">
                            Quay lại{' '}
                            <Link to="/login" className="text-[#111827] font-semibold hover:underline">
                                Đăng nhập
                            </Link>
                        </span>
                    </div>
                </div>
            </div>

            <footer className="pb-6 px-6 flex flex-col items-center gap-4">
                <div className="flex flex-col items-center gap-1">
                    <span className="text-[13px] text-[#a0a0a5]">from</span>
                    <SimplizeOriginalLogo className="h-[18px] w-auto text-[#111827]" />
                </div>
                <div className="flex items-center gap-6 text-[13px] text-[#a0a0a5] text-center justify-center">
                    <a href="/terms" className="underline hover:text-[#111827] transition-colors">Điều khoản dịch vụ</a>
                    <a href="/privacy" className="underline hover:text-[#111827] transition-colors">Chính sách quyền riêng tư</a>
                    <span>&copy;{new Date().getFullYear()} Simplize</span>
                </div>
            </footer>
        </div>
    );
}
